import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CalendarClockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, PRICE, REGULAR_PRICE, LAUNCH_DEADLINE } from '../data/offer';
const rows = [{
  without: 'Improvvisi ogni seduta e speri che tenga',
  with: 'Segui un percorso definito, seduta per seduta'
}, {
  without: 'Il cliente decide di fermarsi e non sai perché',
  with: 'Il cliente vede dove sta andando e lo decide con te'
}, {
  without: 'Riparti da zero con ogni nuova persona',
  with: 'Apri il volume. Segui la fase. Fatto.'
}];
export function Close() {
  return <section aria-labelledby="close-heading" className="w-full bg-sage" data-id="element-47" data-mp="1c5h4gkyu9ulu">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20 text-center" data-id="element-48" data-mp="17abmfx8k5031">
        <h2 id="close-heading" className="font-serif font-black text-white text-[30px] sm:text-5xl leading-[1.1] tracking-tight" data-id="element-49" data-mp="128m9ud5osecu">
          Smetti di improvvisare la seduta numero quattro.
        </h2>

        <p className="mt-5 text-white/85 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-50" data-mp="3vdbybtuio4k0">
          Unisciti ai coach che conducono percorsi con un metodo: una mappa
          condivisa, una direzione per ogni seduta, qualcosa di scritto da
          consegnare. Nessuna promessa di risultato. Solo un processo che si
          vede.
        </p>

        <p className="mt-7 font-bold text-xs sm:text-sm uppercase tracking-[0.14em] text-terracotta" data-id="element-51" data-mp="i08tk2oj8ngp">
          Diagnosi · Credenze · Azione · Cliente bloccato · Chiusura · Pratica
          professionale
          <span className="block mt-1 text-white" data-id="element-52" data-mp="81b14onzk9sf">tutto coperto</span>
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/15 text-left" data-id="element-53" data-mp="d0w7vl9edmfp">
          <table className="w-full" data-id="element-54" data-mp="2ss22c2b5o4i5">
            <thead data-id="element-55" data-mp="2sr0dmv17vjhy">
              <tr data-id="element-56" data-mp="2suo9i0u4whzu">
                <th className="w-1/2 bg-danger-soft px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-danger" data-id="element-57" data-mp="2xrn1odu8meve">
                  ✕ Senza il sistema
                </th>
                <th className="w-1/2 bg-vital-soft px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-vital" data-id="element-58" data-mp="14aqq7ydgxvfq">
                  ✓ Con il sistema
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-dark" data-id="element-59" data-mp="pkjiacl37uta">
              {rows.map(row => <tr key={row.without} className="bg-white align-top" data-id="element-60" data-mp="kkooa060mp40">
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] text-ink-muted" data-id="element-61" data-mp="kilr8w6g3vps">
                    {row.without}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] font-semibold text-ink" data-id="element-62" data-mp="blbgdbxji8le">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-12 rounded-3xl bg-cream border border-cream-dark p-7 sm:p-10" data-id="element-63" data-mp="25w6xj2msivzs">
          <p className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold uppercase tracking-[0.16em] text-terracotta" data-id="element-64" data-mp="20zzupipoy0m2">
            <CalendarClockIcon className="w-4 h-4" aria-hidden="true" data-id="element-65" data-mp="2dhiy3j86qtv5" />
            Prezzo di lancio valido fino al {LAUNCH_DEADLINE}
          </p>
          <p className="mt-5 font-serif font-bold text-ink text-lg sm:text-2xl leading-snug" data-id="element-66" data-mp="2i9tzyrmhkpqc">
            Il Sistema Completo del Coach™ — 6 volumi + 23 schede + 5 bonus
          </p>
          <p className="mt-3 font-serif font-black text-ink text-2xl sm:text-3xl" data-id="element-67" data-mp="1pkwpvbsfhz8o">
            <span className="line-through text-ink-muted font-bold text-xl sm:text-2xl" data-id="element-68" data-mp="1uietcmnofm9a">
              {REGULAR_PRICE}
            </span>{' '}
            <span className="text-terracotta" data-id="element-69" data-mp="1zgpzamaupcm8">{PRICE}</span>
          </p>
          <CtaButton href={CHECKOUT_URL} className="mt-6 w-full sm:w-auto" data-id="element-70" data-mp="24i5jkc57ff3k">
            Sì, voglio Il Sistema Completo del Coach
          </CtaButton>
          <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-ink-soft font-medium" data-id="element-71" data-mp="3azj2j9eugxu2">
            <li className="flex items-center gap-1.5" data-id="element-72" data-mp="3dh2xre4u02qt">
              <LockIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-73" data-mp="3djp2l60c845c" />
              Pagamento 100% sicuro
            </li>
            <li className="flex items-center gap-1.5" data-id="element-74" data-mp="3nfiohfzy59zs">
              <ZapIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-75" data-mp="3nhd9svf4r44e" />
              Accesso immediato
            </li>
            <li className="flex items-center gap-1.5" data-id="element-76" data-mp="3ij20qmwnsxn8">
              <ShieldCheckIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-77" data-mp="a18m5gzv9xn" />
              Garanzia 7 giorni
            </li>
          </ul>
        </div>
      </div>
    </section>;
}